import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { FriendDetailsService } from 'services/frienddetails.service';
import { AlertService } from 'services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserSessionService } from 'services/usersession.service';
import { ReferFriendsBannerComponent } from '../referfriends-banner-dailog/referfriends-banner-dailog.component';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-referfriends-list',
  templateUrl: './referfriends-list.component.html',
  styleUrls: ['./referfriends-list.component.scss']
})
export class ReferFriendsListComponent implements OnInit {
  displayedColumns: string[] = ['fullName', 'email', 'mobile', 'applicationNumber', 'status',];
  dataSource = new MatTableDataSource<any>([]);
  loading = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  showBanner: boolean = true;
  hasActiveRecords: boolean = false;
  encryptedUserId: any;
  filterValue: string = "";
  loadDataList: any;
  filterValueList: any;
  totalEarned: number = 0;

  constructor(private friendService: FriendDetailsService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private userSessionService: UserSessionService,
    public dialog: MatDialog,) { }

  ngOnInit() {
    this.loadData();

    // Reload data when navigated back from the add page with ?refresh=true
    this.route.queryParams.subscribe(params => {
      if (params && (params.refresh === 'true' || params.refresh === true || params.refresh === '1')) {
        this.loadData();
        this.showBanner = false;
      }
    });

    if (this.showBanner) {
      const dialogRef = this.dialog.open(ReferFriendsBannerComponent, {
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('Dialog closed with:', result);
        if (!result) {
          this.showBanner = false;
        }
      });
    }

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  loadData() {
    this.loading = true;
    this.friendService.getActiveEncryptedUserId().subscribe(res => {
      if (res) {
        this.hasActiveRecords = true;
        this.encryptedUserId = res;
        this.friendService.getCustomerReferredUserDetails().subscribe(result => {
          this.loadDataList = result || [];

          this.totalEarned = this.loadDataList.filter(r => r.friendReferralStatusType == 5).length * 400;

          this.dataSource.data = result || [];
          this.loading = false;
        }, err => {
          this.loading = false;
          this.alertService.error('Could not load referred users');
        });
      } else {
        this.loading = false;
      }
    });
  }


  onRefresh() {
    this.loadData();
  }

  onAdd() {
    this.router.navigate(['add'], { relativeTo: this.route });
  }


  onGenerateReferralLink() {
    debugger
    var referralUrl = environment.appBaseUrl + "/register?userId=" + this.encryptedUserId;
    const dialogRef = this.dialog.open(ReferFriendsBannerComponent, {
      data: { referralUrl: referralUrl }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed with:', result);
    });
  }
  onSearch() {
    if (this.filterValue == null || this.filterValue == undefined || this.filterValue == '') {
      this.alertService.warning('Please enter search value to apply filter');
      return;
    }

    this.filterValueList = this.loadDataList.filter(x => x.customerName.toLowerCase().includes(this.filterValue.toLowerCase())
      || x.email.toLowerCase().includes(this.filterValue.toLowerCase())
      || x.mobileNumber.toLowerCase().includes(this.filterValue.toLowerCase()));
    this.dataSource.data = this.filterValueList;
  }

  applyFilter(filterValue: string) {
    this.filterValue = filterValue.trim();
  }

  onKeydown(event) {
    debugger
    if (event.key === "Enter") {
      this.filterValue = event.target.value;
      this.filterValueList = this.loadDataList.filter(x => x.customerName.toLowerCase().includes(this.filterValue.toLowerCase())
        || x.email.toLowerCase().includes(this.filterValue.toLowerCase())
        || x.mobileNumber.toLowerCase().includes(this.filterValue.toLowerCase()));
      this.dataSource.data = this.filterValueList;
    }
  }
}
